import type { ELanguages, UserPlatform, EAppMode } from '@common/enums';

import { createReducer, on } from '@ngrx/store';
import AppActions from './app.actions';

export const APP_FEATURE_KEY = 'app';

export type AppState = {
    isReady: boolean;
    isAdmin: boolean;
    mode: EAppMode;
    error?: string;
    locale: ELanguages;
    platform: UserPlatform;
    dataLayer?: any;
};

export const initialAppState: AppState = {
    isReady: false,
    isAdmin: false,
    mode: null,
    error: null,
    locale: null,
    platform: null,
    dataLayer: null,
};

export const appReducer = createReducer<AppState>(
    initialAppState,
    on(AppActions.initAppSuccess, (state: AppState) => ({ ...state, isReady: true })),
    on(AppActions.initAppFailure, (state: AppState, { error }) => ({ ...state, error })),
    on(AppActions.setIsAdmin, (state: AppState, { isAdmin }) => ({ ...state, isAdmin })),
    on(AppActions.setMode, (state: AppState, { mode }) => ({ ...state, mode })),
    on(AppActions.setLocale, (state: AppState, { locale }) => ({ ...state, locale })),
    on(AppActions.setPlatform, (state: AppState, { platform }) => ({ ...state, platform })),
    on(AppActions.setDataLayer, (state: AppState, { dataLayer }) => ({ ...state, dataLayer }))
);
